export default "__VITE_ASSET__FrsADdMj__"